import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import { isSafariBrowser, getIconPath } from '@tcp/core/src/utils';
import Modal from '@tcp/core/src/components/common/molecules/Modal';
import CouponAndPromos from '@tcp/core/src/components/features/CnC/common/organism/CouponAndPromos/container/Coupon.container';
import Button from '@tcp/core/src/components/common/atoms/Button';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import Image from '@tcp/core/src/components/common/atoms/Image';
import ErrorMessage from '@tcp/core/src/components/features/CnC/common/molecules/ErrorMessage';
import styles, { modalStyles } from '../styles/AfterPayExpressDrawer.style';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../utils/labels/labelUtilty';
import BAGPAGE_LABELS from '../../../../features/CnC/BagPage/container/Bagpage.labels';

const AfterPayExpressDrawer = ({
  className,
  showCouponsDrawer,
  ledgerSummaryData,
  calculatedEstimatedTax,
  closeDrawer,
  continueWithPayment,
  couponApplied,
  afterPayMinOrderAmount,
  afterPayMaxOrderAmount,
}) => {
  const bagpageLabels = getLabelFromCopyOrFromTranslation('checkout.bagPage', BAGPAGE_LABELS);

  const billingLabels = getLabelFromCopyOrFromTranslation('checkout.billing', BAGPAGE_LABELS);

  const afterpayLabels = {
    afterpayCouponsInfo: renderLabel(
      bagpageLabels.lbl_coupon_afterpay_msg,
      'lbl_coupon_afterpay_msg'
    ),
    orderTotalThresholdMessage: renderLabel(
      billingLabels.lbl_orderTotal_threshold_msg,
      'lbl_orderTotal_threshold_msg'
    ),
    unAppliedCoupons: renderLabel(bagpageLabels.lbl_coupon_unapplied, 'lbl_coupon_unapplied'),
    totalLabel: renderLabel(bagpageLabels.lbl_orderledger_total, 'lbl_orderledger_total'),
    afterpayOfferApplied: renderLabel(
      getLabelFromCopyOrFromTranslation('global.cartItemTile', BAGPAGE_LABELS),
      'lbl_orderTotal_threshold_msg'
    ),
    afterpayContinue: renderLabel(
      bagpageLabels.lbl_billing_afterpaySubmit,
      'lbl_billing_afterpaySubmit'
    ),
  };
  const headingProps = {
    headingStyle: { className: 'modal-heading' },
  };
  const isSafari = isSafariBrowser();
  const {
    subTotal = 0,
    shippingTotal = 0,
    giftServiceTotal = 0,
    giftCardsTotal = 0,
    couponsTotal = 0,
    savingsTotal = 0,
    currencySymbol,
  } = ledgerSummaryData;
  const { afterpayCouponsInfo } = afterpayLabels;
  const orderTotal = Math.abs(
    Number(
      subTotal +
        Number(calculatedEstimatedTax) +
        shippingTotal +
        giftServiceTotal -
        giftCardsTotal -
        couponsTotal -
        savingsTotal
    )
  ).toFixed(2);
  const afterEligibilityNotConfirmed = Number(orderTotal) < Number(afterPayMinOrderAmount);

  let orderTotalThresholdMessage =
    afterpayLabels.orderTotalThresholdMessage &&
    afterpayLabels.orderTotalThresholdMessage.replace(
      '[AfterPayMinOrderAmount]',
      afterPayMinOrderAmount
    );
  orderTotalThresholdMessage =
    orderTotalThresholdMessage &&
    orderTotalThresholdMessage.replace('[AfterPayMaxOrderAmount]', afterPayMaxOrderAmount);

  const onCloseClick = () => {
    closeDrawer(false);
  };

  const onCtaClick = () => {
    if (Number(orderTotal) >= Number(afterPayMinOrderAmount)) {
      continueWithPayment();
    }
  };
  return (
    <>
      {showCouponsDrawer ? (
        <React.Fragment>
          <Modal
            fixedWidth
            isOpen
            noPadding
            onRequestClose={() => {
              onCloseClick();
            }}
            heading={afterpayLabels.unAppliedCoupons}
            headingAlign="center"
            overlayClassName="TCPModal__Overlay"
            className={`TCPModal__Content, ${className}`}
            inheritedStyles={modalStyles}
            innerContentClassName={`atb-innerContent`}
            headingFontWeight="bold"
            headingFontFamily="secondary"
            isSafari={isSafari}
            bodyOpenClassName="stop-body-scroll"
            {...headingProps}
          >
            <div className="coupons-container">
              <CouponAndPromos
                additionalClassNameModal="coupon-modal-web"
                idPrefix="desktop"
                fromPaymentModal
                afterpayCouponsInfo={afterpayCouponsInfo}
                spcBag
              />
            </div>
            <div className="cta-section">
              <div className="total-section">
                <BodyCopy
                  className="elem-mt-MED elem-mb-MED"
                  fontWeight="regular"
                  component="p"
                  fontSize="fs16"
                  fontFamily="secondary"
                  textAlign="center"
                >
                  {afterpayLabels.totalLabel}:
                  <BodyCopy
                    fontWeight="extrabold"
                    component="span"
                    fontSize="fs16"
                    fontFamily="secondary"
                    textAlign="center"
                  >
                    {` ${currencySymbol}${orderTotal}`}
                  </BodyCopy>
                </BodyCopy>
                {couponApplied && (
                  <div className="offer-notification">
                    <span>
                      <Image
                        alt="close"
                        src={getIconPath('circle-check-fill-green')}
                        height="19px"
                        width="19px"
                      />
                    </span>
                    <BodyCopy
                      className="elem-ml-XS"
                      fontWeight="extrabold"
                      component="span"
                      fontSize="fs14"
                      fontFamily="secondary"
                    >
                      {afterpayLabels.afterpayOfferApplied}
                    </BodyCopy>
                  </div>
                )}
              </div>
              {afterEligibilityNotConfirmed && (
                <ErrorMessage
                  fontSize="fs12"
                  fontWeight="extrabold"
                  error={orderTotalThresholdMessage}
                  icon="circle-info-red"
                  noBackground
                />
              )}
              <Button
                className="continue-btn"
                buttonVariation="fixed-width"
                fill="BLUE"
                onClick={onCtaClick}
                disabled={afterEligibilityNotConfirmed}
              >
                {afterpayLabels.afterpayContinue}
              </Button>
            </div>
          </Modal>
        </React.Fragment>
      ) : null}
    </>
  );
};

AfterPayExpressDrawer.propTypes = {
  className: PropTypes.string,
  showCouponsDrawer: PropTypes.bool.isRequired,
  ledgerSummaryData: PropTypes.shape({}).isRequired,
  calculatedEstimatedTax: PropTypes.number,
  closeDrawer: PropTypes.func,
  continueWithPayment: PropTypes.func,
};

AfterPayExpressDrawer.defaultProps = {
  className: '',
  calculatedEstimatedTax: 0,
  closeDrawer: () => {},
  continueWithPayment: () => {},
};

export default withStyles(AfterPayExpressDrawer, styles);
export { AfterPayExpressDrawer as AfterPayExpressDrawerVanilla };
